import React, { Component, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Loadable from "react-loadable";

import "../../node_modules/font-awesome/scss/font-awesome.scss";

import Loader from "./layout/Loader";
import Aux from "../hoc/_Aux";
import ScrollToTop from "./layout/ScrollToTop";
import routes from "../route";
import Navigation from "../App/layout/AdminLayout/Navigation/index";
import NavBar from "../App/layout/AdminLayout/NavBar/index";
import PrivateRouter from "../router/PrivateRoute"; //sessionStorage에 userInfo가 있으면 하위 컴포넌트 보여지고 아니면 "/" 가도록
import PublicRouter from "../router/PublicRouter"; //sessionStorage에 userInfo가 없으면 하위 컴포넌트 보여지고 아니면 "/Dashboard/Dashboard" 가도록
import * as cryto from "../commonFunc/Aes256";

// Loadable는  현재 페이지를 렌더링하는데 필요한 코드만 로드되도록 하여 로딩시간 단축할 수 있음
const AdminLayout = Loadable({
  loader: () => import("./layout/AdminLayout"), // 렌더링할 화면
  loading: Loader, //로딩하는 동안 보여줄 화면 설정
});

class App extends Component {
  render() {
    // // 엑세스 토큰 시간 만료 확인 함수
    // function isAccessTokenExpired(accessToken) {
    //   if (!accessToken) {
    //     return true; // 토큰이 없으면 만료됨
    //   }

    //   const tokenData = JSON.parse(atob(accessToken.split(".")[1]));
    //   const expirationTime = tokenData.exp * 1000; // 밀리초로 변환

    //   return Date.now() > expirationTime;
    // }

    // const accessToken = sessionStorage.getItem("Token");
    // const isExpired = isAccessTokenExpired(accessToken);

    //로그인 유지
    const Access = window.sessionStorage.getItem("userInfo");
    //

    //  route.js 안에 route.component가 있다면 해당 컴포넌트를 보여준다.
    //  이렇게 처리를 따로 해놨기 때문에 로그인 회원가입 페이지는 AdminLayout 화면으로 안보여진다.
    const menu = routes.map((route, index) => {
      return route.component ? (
        <Route
          key={index}
          path={route.path}
          //   exact={route.exact}
          name={route.name}
          element={
            <PublicRouter
              authenticated={Access}
              component={<route.component />}
            />
          }
          // element={<route.component />}
        />
      ) : null; // 변수를 선언하고 빈 값을 할당한 상태 (빈 객체)
    });

    return (
      <Aux>
        <ScrollToTop>
          {/* Suspense 안에 있는 컴포넌트가 렌더링 준비할 동안 fallback에 있는 Loader컴포넌트를 보여준다. */}
          <Suspense fallback={<Loader />}>
            <Routes>
              {menu}
              <Route
                path="*"
                element={
                  <PrivateRouter
                    authenticated={Access}
                    component={<AdminLayout />}
                  />
                }
              />
              {/* {menu}
              <Route path="*" element={<AdminLayout />} /> */}
              {/* {!Access ? [menu] : <Route path="*" element={<AdminLayout />} />} */}
            </Routes>
          </Suspense>
        </ScrollToTop>
      </Aux>
    );
  }
}

export default App;
